import { GraduationServicePath, PLANS } from "utils/constants";
import EditInternshipPlans from "./Edit";
import permissions from "app/permissions";

export const resources = {
  isMenu: false,
  name: GraduationServicePath + "update/" + PLANS + "/:id",
  title: "Редакция на стажантски план",
  custom: <EditInternshipPlans />,
  permission: permissions.canManageInternshipPlans,
};
